import React, { useState, useRef } from 'react';
import './Subscribe.scss';
import emailjs from '@emailjs/browser';
import { 
  TextField, 
  Button,  
  Typography, 
  Box, 
  Grid, 
  Paper,
  createTheme,
  ThemeProvider
} from '@mui/material';
import { styled } from '@mui/system';

// Create a custom theme with the specified colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#ff551a', // Orange
    },
    secondary: {
      main: '#341f71', // Violet
    },
    warning: {
      main: '#eaaf3b', // Mustard
    },
    success: {
      main: '#4caf50', // Green
    },
    error: {
      main: '#f44336', // Red
    },
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#341f71',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#341f71',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: '#341f71',
          },
        },
      },
    },
  },
});

const StyledPaper = styled(Paper)(({ theme }) => ({
  maxWidth: '42rem',
  margin: '3rem auto',
  padding: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6),
  },
  backgroundColor: 'transparent',
  boxShadow: 'none',
}));

const RequiredLabel = styled('span')({
  color: 'red',
  marginLeft: '4px',
});

export default function ConsultationForm() {
  const [formData, setFormData] = useState({
    user_name: '',
    user_email: '',
  });

  const [message, setMessage] = useState({ text: '', type: '' });
  const form = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prevState) => {
      const updatedFormData = { ...prevState, [name]: value };
  
      return updatedFormData;
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_5xjce2b', 'template_g0iybeb', form.current, {
        publicKey: 'kZZkcyvdB31gWkPKA',
      })
      .then(
        () => {
          setMessage({ text: 'Tu suscripción se procesó con éxito!', type: 'success' });
          // Resetear el formulario después de enviar
          setFormData({
            user_name: '',
            user_email: ''
          });
        },
        (error) => {
          setMessage({ text: 'Error al enviar la consulta. Intenta nuevamente.', type: 'error' });
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <ThemeProvider theme={theme}>
      <StyledPaper elevation={3}>
        <Typography variant="h1" component="h4" gutterBottom color="secondary" sx={{ fontSize: '32px', marginBottom: '3rem', textAlign: 'center', fontFamily: 'Lora, serif', fontWeight: '500' }}>
          Suscribite ahora para recibir novedades, recursos gratuitos y más
        </Typography>
        
        <form ref={form} onSubmit={sendEmail}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <TextField
                required
                fullWidth
                label="Nombre Completo"
                name="user_name"
                value={formData.user_name}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                required
                fullWidth
                label="Correo Electrónico"
                name="user_email"
                type="email"
                value={formData.user_email}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Button 
                type="submit" 
                variant="contained" 
                color="secondary" 
                fullWidth 
                size="large"
                sx={{ 
                  mt: 2, 
                  py: 1.5, 
                  fontSize: '1.1rem',
                  '&:hover': {
                    backgroundColor: 'secondary.dark',
                  }
                }}
              >
                Suscribirse
              </Button>
            </Grid>
          </Grid>
        </form>
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          <RequiredLabel>*</RequiredLabel> Campos Requeridos
        </Typography>
        {/* Mensaje de confirmación o error */}
        {message.text && (
          <Box sx={{ bgcolor: message.type === 'success' ? 'success.main' : 'error.main', p: 2, borderRadius: 1, mb: 2 }}>
            <Typography variant="body2" color="white">
              {message.text}
            </Typography>
          </Box>
        )}
      </StyledPaper>
    </ThemeProvider>
  );
}